import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import EcrionSwitch from '../form/input/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
/**
 * A representation of a boolean value as a switch button.
 * @param {import('./types').SwitchFormatterProps} props */

var SwitchFormatter = function SwitchFormatter(props) {
  var value = props.value,
      label = props.label,
      labelPlacement = props.labelPlacement,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["value", "label", "labelPlacement", "disabled"]);

  var control = React.createElement(EcrionSwitch, Object.assign({
    value: value ? 'Yes' : 'No',
    checked: Boolean(value),
    disabled: disabled
  }, rest));

  if (label) {
    return React.createElement(FormControlLabel, {
      control: control,
      label: label,
      labelPlacement: labelPlacement,
      disabled: disabled
    });
  } else {
    return control;
  }
};

SwitchFormatter.defaultProps = {
  labelPlacement: 'end',
  disabled: false
};
export default SwitchFormatter;